import { isIntelbrasTenant } from '../isIntelbrasTenant/isIntelbrasTenant';

export const getLiteName = () => {
  return isIntelbrasTenant() ? 'CVE-Lite' : 'Dash-Lite';
};
